import { normalize, schema } from 'normalizr';

const hierarchyItem = new schema.Entity('hierarchyItems');
const setItem = new schema.Entity('setItems');

export const normalizeHierarchy = hierarchy => normalize(hierarchy, [hierarchyItem]);
export const normalizeSets = sets => normalize(sets, [setItem]);
